import { usePage } from "@inertiajs/react"
import { Bell, X } from "lucide-react"
import { useCallback, useState } from "react"

import { Button } from "@/components/ui/button"
import { isPushSupported, subscribeToPush } from "@/lib/push-notifications"

export default function PushNotificationPrompt() {
  const { auth } = usePage().props as {
    auth: { user: { id: number }; vapid_public_key?: string }
  }

  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return true
    return localStorage.getItem("push_prompt_dismissed") === "true"
  })
  const [loading, setLoading] = useState(false)

  const vapidPublicKey = auth.vapid_public_key

  const handleEnable = useCallback(() => {
    if (!vapidPublicKey) return
    setLoading(true)
    void subscribeToPush(vapidPublicKey).then((success) => {
      if (success) {
        setDismissed(true)
        localStorage.setItem("push_prompt_dismissed", "true")
      }
      setLoading(false)
    })
  }, [vapidPublicKey])

  const handleDismiss = useCallback(() => {
    setDismissed(true)
    localStorage.setItem("push_prompt_dismissed", "true")
  }, [])

  if (
    dismissed ||
    !vapidPublicKey ||
    (typeof window !== "undefined" && !isPushSupported())
  ) {
    return null
  }

  return (
    <div className="border-krown-400/30 bg-krown-400/10 mb-4 flex items-center gap-3 rounded-lg border p-3">
      <Bell className="text-krown-300 h-5 w-5 shrink-0" />
      <p className="text-foreground flex-1 text-sm">
        Activá las notificaciones push para no perderte mensajes ni visitas a tu
        perfil.
      </p>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" onClick={handleEnable} disabled={loading}>
          Activar
        </Button>
        <button
          onClick={handleDismiss}
          className="text-muted-foreground hover:text-foreground"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
